import { render, staticRenderFns } from "./CardID.vue?vue&type=template&id=f3c99ae8&scoped=true&"
import script from "./CardID.vue?vue&type=script&lang=js&"
export * from "./CardID.vue?vue&type=script&lang=js&"
import style0 from "./CardID.vue?vue&type=style&index=0&id=f3c99ae8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3c99ae8",
  null
  
)

export default component.exports